<template>
  <div class="centent">
    <div class="titlefont" :class="{ showRound: showRound }">
      <div class="titleAnimation">
        <div class="title">还有疑问？ 看看这里</div>
      </div>
    </div>
    <div class="cont">
      <div :class="{ rowllInfoBox: true, showRound: showRound }">
        <el-card class="box-card itemA">
          <div class="title">Q：新媒体运营好找工作吗？</div>
          <div class="des">
            <span>A：</span>
            <p>
              据《2020互联网从业人才报告》数据，目前市场上对运营类人才的需求仅次于编程语言类人才，排在第二位，比设计人才、产品人才需求都要多。新媒体运营作为新兴的职位，不管是互联网企业还是传统企业都在利用互联网做营销宣传，运营人才在未来<i>5~10</i>年是需求很高的岗位。
            </p>
          </div>
          <div class="itemBg1"></div>
        </el-card>
        <el-card class="box-card itemB">
          <div class="title">Q：为什么选择传智教育的新媒体？</div>
          <div class="des">
            <span>A：</span>
            <p>
              学习周期短、学费低！传智新媒体运营学习周期仅 <i>93天</i> ，学费<i>14980元</i>。2020年全年就业率高达<i>96.41%</i>，就业均薪高达<i>10634元</i>。
            </p>
          </div>
          <div class="itemBg2"></div>
        </el-card>
        <el-card class="box-card lastCard itemC">
          <div class="title">Q：学完能找到多少钱的工作？</div>
          <div class="des">
            <span>A：</span>
            <p>
              根据市场行情，初入职场的新媒体运营专员，月薪<i>6k~8k</i>；工作两到三年的中级新媒体运营，月薪<i>8k~15k</i>；工作五年左右，可成为新媒体运营或运营总监，平均月薪<i>20k~30k</i>。 新媒体就业前景广阔，根据往期数据，纯小白、无基础的毕业学员，平均薪资也可到<i>9~10k</i>左右。
            </p>
            
          </div>
          <div class="itemBg3"></div>
        </el-card>
        <!-- <div class="service"><img src="./../images/service.png" /></div> -->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    showRound: {
      type: Boolean,
      required: true,
      default: () => {},
    },
  },
  data() {
    return {};
  },
  computed: {},
  created() {},
  mounted() {},
  methods: {},
};
</script>
<style src="./../style.scss" rel="stylesheet/scss" lang="scss" scoped></style>
<style lang="scss" scoped>
</style>
